import { Pipe, PipeTransform } from '@angular/core';
import { Role } from 'src/app/backend-client/models/Backend/Core/Infrastructure/Aggregates/Identity/role';
import { MxIdentityService } from 'src/app/core/services';

@Pipe({
 standalone: false,
  name: 'mxMenuRights',
})
export class MxMenuRightsPipe implements PipeTransform {
  constructor(private identityService: MxIdentityService) {}
  transform(value: Role[]): any {
    const currentRole = Number(this.identityService.accountValue?.role);
    return value.includes(currentRole as Role);
  }
}

